// extracted by mini-css-extract-plugin
export default {"auth_form":"D9YIYF","auth_form__info":"uEuXXi","auth_form__info__alert":"K30HEJ","auth_form__info__alert__message":"lmDanL","auth_form__button":"MCuJbT"};